import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Divider, ListItemIcon, Box } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { TOKENS } from "./tokens";

/**
 * Kebab IconButton that opens an MUI Menu.
 * `actions = [{ key, icon, label, danger?, divider?, onClick? }]`.
 * A row with `divider: true` renders a divider instead of a clickable item.
 */
const RowMenu = ({ actions = [] }) => {
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);

  const handleOpen = (e) => {
    e.stopPropagation();
    setAnchor(e.currentTarget);
  };
  const handleClose = (e) => {
    if (e) e.stopPropagation?.();
    setAnchor(null);
  };
  const handleSelect = (action) => (e) => {
    e.stopPropagation();
    setAnchor(null);
    action.onClick?.(e);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOpen}
        sx={{
          color: TOKENS.fg2,
          "&:hover": { background: TOKENS.bgSunken, color: TOKENS.fg1 },
        }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 0.5,
            minWidth: 180,
            border: `1px solid ${TOKENS.border}`,
            boxShadow: TOKENS.shadowM,
            borderRadius: `${TOKENS.radiusXs}px`,
          },
        }}
      >
        {actions.map((a) =>
          a.divider ? (
            <Divider key={a.key || `div-${a.label || Math.random()}`} sx={{ my: 0.5 }} />
          ) : (
            <MenuItem
              key={a.key || a.label}
              onClick={handleSelect(a)}
              sx={{
                fontSize: 13,
                color: a.danger ? TOKENS.dangerInk : TOKENS.fg1,
                "&:hover": {
                  background: a.danger ? TOKENS.dangerBg : TOKENS.bgSunken,
                },
              }}
            >
              {a.icon ? (
                <ListItemIcon
                  sx={{
                    minWidth: 28,
                    color: a.danger ? TOKENS.dangerInk : TOKENS.fg2,
                  }}
                >
                  {a.icon}
                </ListItemIcon>
              ) : (
                <Box sx={{ width: 28 }} />
              )}
              {a.label}
            </MenuItem>
          )
        )}
      </Menu>
    </>
  );
};

export default RowMenu;
